import { P0, S, abs, frac } from '../../geometry';

export const hourglass = {
  name: 'Hourglass',
  colors: ['#161616', '#C46A3E'],
  draw(m, t) {
    let L = 0.45,
      flow = 0,
      pose = P0();
    pose.rot = 2 * S(t * 1.2);
    if (m === 'happy') {
      pose.rot = 12 * S(t * 7);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the sand keeps running.
    if (m === 'thinking') {
      L = frac(t * 0.4);
      flow = 1;
      pose.rot = 4 * S(t * 1.6);
    }
    if (m === 'talking') pose.rot = 5 * S(t * 8);
    if (m === 'surprised') {
      pose.ty = -3;
      pose.rot = S(t * 26);
    }
    if (m === 'paused') pose.rot = 10 + S(t * 0.8);
    const ys = 41 + L * 8,
      hw = 50 - (32 + ((ys - 34) / 18) * 14) - 2.5,
      pile = 3 + L * 10,
      fall = frac(t * 2.2);
    return {
      strokes: [
        {
          c: 'a',
          pts: [
            [24, 20],
            [76, 20],
          ],
        },
        {
          c: 'a',
          pts: [
            [24, 84],
            [76, 84],
          ],
        },
        {
          c: 'a',
          pts: [
            [31, 22],
            [32, 34],
            [46, 52],
            [32, 70],
            [31, 82],
          ],
        },
        {
          c: 'a',
          pts: [
            [69, 22],
            [68, 34],
            [54, 52],
            [68, 70],
            [69, 82],
          ],
        },
        {
          c: 'b',
          pts: [
            [50 - hw, ys],
            [50 + hw, ys],
          ],
        },
        {
          c: 'b',
          pts: [
            [38, 82],
            [50, 82 - pile],
            [62, 82],
          ],
        },
        {
          c: 'b',
          pts: [
            [50, 55 + fall * 15],
            [50, 59 + fall * 15],
          ],
          snap: true,
          o: flow * S(Math.PI * fall),
          detail: true,
        },
      ],
      eyes: { x: 50, y: 33 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f) {
    const [L, Rt] = [f.strokes[2].pts, f.strokes[3].pts];
    const glass = {
      c: 'a',
      fill: true,
      pts: [...L, ...Rt.slice().reverse(), L[0]],
      n: 34,
    };
    return {
      ...f,
      strokes: [
        f.strokes[0],
        f.strokes[1],
        glass,
        { ...f.strokes[4], o: 0 },
        ...f.strokes.slice(5),
      ],
    };
  },
};
